<template>
  <v-app>
    <NavComponent/>
    <router-view></router-view>
    <FootComponent/>
  </v-app>
</template>

<script>
import NavComponent from './components/Head+Foot/NavComponent.vue'
import FootComponent from './components/Head+Foot/FootComponent.vue'

export default {
  name: 'App',
  components: { 
    NavComponent,
    FootComponent
  },
  data: () => ({

  })
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=BenchNine:300|Amatic+SC|Baloo+Tammudu|Cabin:400,700|Quicksand:500,700|Bowlby+One|Lato:300,400,400italic,600,700|Roboto:400,500,700|Montserrat:100,200,400|Nunito:400,600,700|Raleway:300,400,500,600,700");
@import url("https://use.typekit.net/dzk8mgi.css");
@font-face { font-family: "Geomanist"; src: url("./images/fonts/Geomanist-Regular.otf") format("opentype");}
@font-face { font-family: "Voga"; src: url("./images/fonts/Voga-Medium.otf") format("opentype");}
@font-face { font-family: "Simplifica"; src: url("./images/fonts/SIMPLIFICA Typeface.ttf") format("truetype");}
html{ 
  font-size: 62.5%;
  overflow: scroll;
  overflow-x: hidden;}
::-webkit-scrollbar {
  width: 0px;}
a{text-decoration: none !important;}
/*========================POSITIONING=======*/
.ontop { opacity: 0;}
.ontop:hover { opacity: 1;}
.zero-pos{
	margin: 0;
	padding: 0;
	top: 0;
	left: 0;}
/*========================FONTS=============*/
.simp{font-family: "Simplifica";}
.voga{ font-family: "Voga";}
.geom{ font-family: "Geomanist";}
.fenix{ font-family: 'Fenix', serif;}
.cab {font-family: 'Cabin', sans-serif; font-weight: 400;}
.rale {font-family: 'Raleway', sans-serif; font-weight: 300;}
.lato {font-family: 'Lato', sans-serif; font-weight: 300;}
.mont {font-family: 'Montserrat', sans-serif; font-weight: 200;}
.bat{ font-family: acier-bat-solid, sans-serif; font-weight: 400;}
.goth{ font-family: alternate-gothic, sans-serif; font-weight: 600;}
.paral{ font-family: paralucent-condensed,sans-serif; font-weight: 600;}
.amatic{ font-family: 'Amatic SC'; font-weight: 800;}
.corner{ font-family: corner-store-jf, sans-serif; font-weight: 400;}
/*========================COLOURS==========*/
.turq {color: #4EA792 !important;}
.purp {color: #8961A0 !important;}
.whiteTxt {color: #fff;}
.drkGrey {color: #323232CC;}
.grey {color: grey;}
.lightGrey {color: #BCBCBC;}
.black {color: #000;}
.turqBg { background-color: #4EA792EF;}
.purpBg { background-color: #8A648C;}
.whiteBg { background-color: white;}
.drkGreyBg { background-color: #323232;}
.blackBg { background-color: #000;} 
/*========================HEADINGS==========*/
h1, h2, h3, h4 {
	position: relative;
	display: block;
	width: 100%;
	padding: 0;
	margin: 0;}
/*========================WIDTHS==========*/
.w50 {width: 50%;}
.w80 {width: 80%;}
.w85 {width: 85%;}
/*====================================FONT-WEIGHTS====*/
.fw3 {font-weight: 300 !important;}
.fw4 {font-weight: 400 !important;}
.fw5 {font-weight: 500 !important;}
.fw6 {font-weight: 600 !important;}
.fw7 {font-weight: 700 !important;}
.fw8 {font-weight: 800 !important;}
.fw9 {font-weight: 900 !important;}
/*====================================FONT-ALIGNMENT===*/
.ceTxt { text-align: center !important;}
.leTxt { text-align: left;}
.riTxt { text-align: right;}
/*========================FONT-SIZE==========*/
.fs12{font-size: 12px !important;}
.fs14{font-size: 14px !important;}
.fs16{font-size: 16px !important;}
.fs16{font-size: 16px !important;}
.fs18{font-size: 18px !important;}
.fs20{font-size: 20px !important;}
.fs22{font-size: 22px !important;}
.fs24{font-size: 24px !important;}
.fs26{font-size: 26px !important;}
.fs28{font-size: 28px !important;}
.fs30{font-size: 30px !important;}
.fs32{font-size: 32px !important;}
.fs34{font-size: 34px !important;}
.fs36{font-size: 36px !important;}
.fs38{font-size: 38px !important;}
.fs40{font-size: 40px !important;}
.fs42{font-size: 42px !important;}
.fs44{font-size: 44px !important;}
.fs46{font-size: 46px !important;}
.fs48{font-size: 48px !important;}
.fs50{font-size: 50px !important;}
/*========================LINE-HEIGHT==========*/
.lh08{line-height: 08px !important;}
.lh10{line-height: 10px !important;}
.lh12{line-height: 12px !important;}
.lh14{line-height: 14px !important;}
.lh16{line-height: 16px !important;}
.lh18{line-height: 18px !important;}
.lh20{line-height: 20px !important;}
.lh22{line-height: 22px !important;}
.lh24{line-height: 24px !important;}
.lh26{line-height: 26px !important;}
.lh28{line-height: 28px !important;}
.lh30{line-height: 30px !important;}
.lh32{line-height: 32px !important;}
.lh34{line-height: 34px !important;}
.lh36{line-height: 36px !important;}
.lh38{line-height: 38px !important;}
.lh40{line-height: 40px !important;}
.lh42{line-height: 42px !important;}
.lh44{line-height: 44px !important;}
.lh46{line-height: 46px !important;}
.lh48{line-height: 48px !important;}
.lh50{line-height: 50px !important;}
.noise{
	position: absolute;
	display: block;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	background-image: url(./images/backgrounds/noisyTexture.png);
  background-repeat: repeat; }
.filler{height: 30px;}
.z100{z-index: 100;}
</style>
